import { render, staticRenderFns } from "./batching.vue?vue&type=template&id=c01252a8&scoped=true&"
import script from "./batching.vue?vue&type=script&lang=js&"
export * from "./batching.vue?vue&type=script&lang=js&"
import style0 from "./batching.vue?vue&type=style&index=0&id=c01252a8&lang=less&scoped=true&"
import style1 from "./batching.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01252a8",
  null
  
)

export default component.exports